module.exports = __webpack_public_path__ + "static/media/997733.5cd9b6b8.jpg";